import APLogo from "./APLogo";

export { APLogo };

export default APLogo;
